/**路由切换动画 */
export enum TransitionEnum {
	ZOOM_FADE = "zoom-fade",
	ZOOM_OUT = "zoom-out",
	FADE_SIDE = "fade-slide",
	FADE = "fade",
	FADE_BOTTOM = "fade-bottom",
	FADE_SCALE = "fade-scale"
}

export const transitionOptions = [
	TransitionEnum.ZOOM_FADE,
	TransitionEnum.FADE,
	TransitionEnum.ZOOM_OUT,
	TransitionEnum.FADE_SIDE,
	TransitionEnum.FADE_BOTTOM,
	TransitionEnum.FADE_SCALE
].map(item => {
	return {
		label: item,
		value: item
	}
})

/**  过渡动画配置 */
export interface TransitionSetting {
	/**
	 * 是否启用过渡动画
	 */
	enable: boolean

	/**
	 * 过渡动画类型
	 */
	basicTransition: TransitionEnum

	/**
	 * 是否在打开页面时显示加载动画
	 */
	showPageLoding: boolean

	/**
	 * 是是否在打开页面时显示加载进度条
	 */
	showPageProgress: boolean
}

/** 默认过渡动画配置 */
export const transitionSetting: TransitionSetting = {
	enable: true,
	basicTransition: TransitionEnum.FADE_BOTTOM,
	showPageLoding: true,
	showPageProgress: true
}
